import { GlobalStorage } from "../../lib/global-client-storage";
import { o_global } from "../namespaces";

/*                                              */
o_global.Storage ||= GlobalStorage;
